"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var VulnerableCustomerAdditionalSupportRecord_1 = require("../../model/VulnerableCustomerAdditionalSupportRecord");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var Page_1 = require("../../pages/Page");
var operators_1 = require("rxjs/operators");
var VulnerableCustomerAdditionalSupportModal = /** @class */ (function (_super) {
    __extends(VulnerableCustomerAdditionalSupportModal, _super);
    function VulnerableCustomerAdditionalSupportModal(props) {
        var _this = _super.call(this, props) || this;
        _this.CATEGORY = "vulnerableCustomerCategory";
        _this.STATUS = "vulnerableCustomerStatus";
        _this.renderCategoryChoice = function () {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "vc-support-categories", children: (0, jsx_runtime_1.jsx)("b", { className: "font-weight-semi-bold", children: "Category" }) }), (0, jsx_runtime_1.jsx)("div", { className: "input-group w-md-75", children: (0, jsx_runtime_1.jsxs)("select", { id: "vc-support-categories", className: "form-control", onChange: _this.handleCategoryChange, value: _this.state.record.category, children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "Please select" }), _this.renderOptions(_this.state.categoryOptions)] }) })] }));
        };
        _this.renderStatusChoice = function () {
            return ((0, jsx_runtime_1.jsx)("div", { className: "form-group", children: (0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "item-categories", children: (0, jsx_runtime_1.jsx)("b", { className: "font-weight-semi-bold", children: "Status" }) }), (0, jsx_runtime_1.jsx)("div", { className: "input-group w-md-75", children: (0, jsx_runtime_1.jsxs)("select", { id: "vc-status-categories", className: "form-control", onChange: _this.handleStatusChange, value: _this.state.record.status, children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "Please select" }), _this.renderOptions(_this.state.statusOptions)] }) })] }) }));
        };
        _this.renderDescriptionInput = function () {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "description", children: "Additional Support Required" }), (0, jsx_runtime_1.jsx)("div", { className: "input-group w-100", children: (0, jsx_runtime_1.jsx)("textarea", { id: "description", className: "form-control", value: _this.state.record.description || "", maxLength: 500, onChange: _this.handleDescriptionChange }) })] }));
        };
        _this.handleDescriptionChange = function (event) {
            var record = _this.state.record;
            record.description = event.target.value;
            _this.setState({ record: record }, function () { return _this.validateForm(); });
        };
        _this.handleCategoryChange = function (event) {
            var record = _this.state.record;
            record.category = event.target.value;
            _this.setState({ record: record }, function () { return _this.validateForm(); });
        };
        _this.handleStatusChange = function (event) {
            var record = _this.state.record;
            record.status = event.target.value;
            _this.setState({ record: record }, function () { return _this.validateForm(); });
        };
        _this.handleSave = function () {
            if (!_this.state.isFormValid || _this.state.isSaving) {
                return;
            }
            _this.setState({ isSaving: true });
            _this.saveRecord()
                .catch(function () {
                _this.setState({ isSaving: false });
            });
        };
        _this.validateForm = function () {
            var record = _this.state.record;
            var isCategoryValid = Boolean(record.category);
            var isStatusValid = Boolean(record.status);
            var isDescriptionValid = Boolean(record.description);
            _this.setState({
                isFormValid: isCategoryValid && isStatusValid && isDescriptionValid
            });
            return isCategoryValid && isStatusValid && isDescriptionValid;
        };
        _this.incrementLoadingQueueSize = function (callback) {
            _this.setState({
                loadingQueueSize: _this.state.loadingQueueSize + 1
            }, callback);
        };
        _this.decrementLoadingQueueSize = function (callback) {
            if (_this.state.loadingQueueSize === 0) {
                return;
            }
            _this.setState({
                loadingQueueSize: _this.state.loadingQueueSize - 1
            }, callback);
        };
        _this.loading = function () {
            return _this.state.loadingQueueSize !== 0 && !_this.state.categoryOptions && !_this.state.statusOptions;
        };
        _this.state = {
            record: _this.props.record ? _this.props.record : new VulnerableCustomerAdditionalSupportRecord_1.default(),
            isValueValid: true,
            isFormValid: false,
            loadingQueueSize: 0,
            categoryOptions: [],
            statusOptions: [],
            isSaving: false
        };
        return _this;
    }
    VulnerableCustomerAdditionalSupportModal.prototype.componentDidMount = function () {
        var _this = this;
        this.incrementLoadingQueueSize(function () {
            _this.lookupService.fetchLookupValues(_this.CATEGORY, "en-UK")
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe(function (lookupValues) {
                _this.setState({
                    categoryOptions: lookupValues,
                });
            });
        });
        this.incrementLoadingQueueSize(function () {
            _this.lookupService.fetchLookupValues(_this.STATUS, "en-UK")
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe(function (lookupValues) {
                _this.setState({
                    statusOptions: lookupValues,
                });
            });
        });
        this.validateForm = this.validateForm.bind(this);
    };
    VulnerableCustomerAdditionalSupportModal.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { id: "vc-support-modal", className: "my-4 vc-additional-support-modal", isOpen: this.props.isOpen, toggle: this.props.onClose, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { className: "w-100 text-center", toggle: this.props.onClose, close: (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.props.onClose }), children: (0, jsx_runtime_1.jsx)("div", { className: "mb-4 mt-2 font-weight-bold w-100 text-center", children: (this.props.newAdditionalSupport ? "Add" : "Edit") + " additional support" }) }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalBody, { className: "py-0 ml-4 mr-4 mt-4", children: [!this.loading() && this.renderCategoryChoice(), !this.loading() && this.renderStatusChoice(), this.renderDescriptionInput()] }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalFooter, { className: "d-block custom-margin-mobile-cut-sides mx-auto modal-footer d-flex flex-column", children: [(0, jsx_runtime_1.jsx)("button", { type: "button", id: "save-support-button", disabled: !this.state.isFormValid || this.state.isSaving, className: "btn btn-primary btn-add display-block mb-1 ".concat((!this.state.isFormValid || this.state.isSaving) ? "btn-disabled" : ""), onClick: this.handleSave, children: (this.props.newAdditionalSupport ? "Add" : "Edit") + " support" }), (0, jsx_runtime_1.jsx)("button", { type: "button", id: "close-support-button", className: "btn btn-back display-block mb-2", onClick: this.props.onClose, children: "Cancel" })] })] }));
    };
    VulnerableCustomerAdditionalSupportModal.prototype.renderOptions = function (options) {
        var optionsElements = [];
        for (var i = 0; i < options.length; i++) {
            optionsElements.push((0, jsx_runtime_1.jsx)("option", { value: options[i].value, children: options[i].value }, options[i].id));
        }
        return optionsElements;
    };
    VulnerableCustomerAdditionalSupportModal.prototype.saveRecord = function () {
        var _this = this;
        this.state.record.policyNumber = this.props.policyNumber;
        this.state.record.partyReference = this.props.customerReferenceNumber;
        if (this.props.newAdditionalSupport) {
            return this.supportPortalService
                .createAdditionalSupportRecord(this.state.record)
                .toPromise()
                .then(function (record) {
                _this.setState({ record: record });
                _this.props.onSuccess(record);
            })
                .catch(function (error) {
                _this.props.onClose();
                throw error;
            });
        }
        return this.supportPortalService
            .updateAdditionalSupportRecord(this.state.record)
            .toPromise()
            .then(function () {
            _this.props.onSuccess(_this.state.record);
        })
            .catch(function (error) {
            _this.props.onClose();
            throw error;
        });
    };
    VulnerableCustomerAdditionalSupportModal.contextType = Page_1.PageContext;
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], VulnerableCustomerAdditionalSupportModal.prototype, "supportPortalService", void 0);
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.FalconLookupService),
        __metadata("design:type", Object)
    ], VulnerableCustomerAdditionalSupportModal.prototype, "lookupService", void 0);
    return VulnerableCustomerAdditionalSupportModal;
}(React.Component));
exports.default = VulnerableCustomerAdditionalSupportModal;
//# sourceMappingURL=VulnerableCustomerAdditionalSupportModal.js.map